import React, { useState } from "react";
import API_URL from "../config";
import "../styles/Formularios.css";
import { useGlobal } from "../context/ContenedorGlobal";
import InputGenerico from "./InputGenerico";
import InputContrasena from "./InputContrasena";
import { useApiFetch } from "../utils/apiFetch";

function CambiarContrasena() {
    const { logout, setModuloActual, setSubModuloActual } = useGlobal();
    const [idTecnico, setIdTecnico] = useState("");
    const [passwordActual, setPasswordActual] = useState("");
    const [passwordNueva, setPasswordNueva] = useState("");
    const [passwordConfirm, setPasswordConfirm] = useState("");
    const [error, setError] = useState("");
    const [paso, setPaso] = useState(1);
    const [success, setSuccess] = useState("");
    const [ocultarForm, setOcultarForm] = useState(false);
    const apiFetch = useApiFetch();

    // Validar las características de la contraseña
    const validarPassword = (pwd) => {
        const regex =
            /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,}$/;
        return regex.test(pwd);
    };

    // Función para validar credenciales del usuario
    const handleValidarCredenciales = async (e) => {
        e.preventDefault();
        setError("");

        if (!idTecnico || !passwordActual) {
            setError("Debe ingresar número de empleado y contraseña.");
            setTimeout(() => setError(""), 2000);
            return;
        }

        // Validación del número de empleado
        if (!/^\d{7}$/.test(idTecnico)) {
            setError("Ingrese exactamente 7 dígitos para el número de empleado.");
            setTimeout(() => setError(""), 3000);
            return;
        }

        // Validar contraseña 
        if (!validarPassword(passwordActual)) {
            setError("La contraseña debe cumplir los requisitos marcados en rojo.");
            setTimeout(() => setError(""), 3000);
            return;
        }

        try {
            const response = await fetch(`${API_URL}/validar_login.php`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                credentials: "include",
                body: JSON.stringify({
                    id_tecnico: idTecnico,
                    contrasena: passwordActual,
                }),
            });

            const data = await response.json();

            if (data.status === "ok") {
                setPaso(2); // Habilitar inputs de nueva contraseña
            } else {
                setError(data.message || "Credenciales incorrectas.");
                setTimeout(() => setError(""), 3000);
            }
        } catch (err) {
            setError("Error de conexión con el servidor.");
            setTimeout(() => setError(""), 3000);
        }
    };

    // Cambiar contraseña después de validar al usuario
    const handleCambiarContrasena = async (e) => {
        e.preventDefault();
        setError("");
        setSuccess("");

        if (!validarPassword(passwordNueva)) {
            setError("La nueva contraseña debe cumplir los requisitos marcados en rojo.");
            setTimeout(() => {
                setError("");
            }, 3000);
            return;
        }
        if (passwordNueva !== passwordConfirm) {
            setError("Las contraseñas no coinciden.");
            setTimeout(() => {
                setError("");
            }, 3000);
            return;
        }

        try {
            const data = await apiFetch("cambiar_contrasena.php", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ contrasena_nueva: passwordNueva })
            }, logout);

            if (data.status === "ok") {
                setPaso(null);
                setSuccess("Contraseña cambiada correctamente.");

                // Después cerrar sesión y redirigir
                setTimeout(async () => {
                    await logout();
                    setModuloActual("Autenticación");
                    setSubModuloActual(null);
                }, 2000);
            } else {
                setError(data.message || "Error al cambiar la contraseña.");
            }
        } catch (err) {
            setError("Error de conexión con el servidor.");
        }
    };

    // Mostrar al usuario
    return (
        <div className="sesion-form">
            <>
                {error && <div className="error">{error}</div>}
                {success && <div className="success">{success}</div>}
            </>

            {paso === 1 && (
                <form onSubmit={handleValidarCredenciales}>

                    <InputGenerico
                        value={idTecnico}
                        setValue={setIdTecnico}
                        label="Número de empleado"
                        maxLength={7}
                        allowedChars="0-9"
                        placeholder="7120000"
                        title="Debe contener exactamente 7 dígitos"
                    />

                    <InputContrasena
                        contrasena={passwordActual}
                        setContrasena={setPasswordActual}
                        label="Contraseña actual"
                    />

                    <div className="form-buttons">
                        <button type="submit">Validar credenciales</button>
                    </div>

                </form>
            )}

            {paso === 2 && (
                <form onSubmit={handleCambiarContrasena}>

                    <InputContrasena
                        contrasena={passwordNueva}
                        setContrasena={setPasswordNueva}
                        label="Nueva contraseña"
                    />

                    <InputContrasena
                        contrasena={passwordConfirm}
                        setContrasena={setPasswordConfirm}
                        label="Confirmar nueva contraseña"
                    />

                    <div className="form-buttons">
                        <button type="submit">Cambiar contraseña</button>
                    </div>
                </form>
            )}
        </div>
    );
}

export default CambiarContrasena;